import { IActivePass, IPassGroup } from '../../models'

export enum WalletTypeKeys {
  FETCH_ACTIVE_PASSES = 'FETCH_ACTIVE_PASSES',
  FETCHING_ACTIVE_PASSES = 'FETCHING_ACTIVE_PASSES',
  FETCH_ACTIVE_PASSES_SUCCESSFUL = 'FETCH_ACTIVE_PASSES_SUCCESSFUL',
  FETCH_AVAILABLE_PASSES = 'FETCH_AVAILABLE_PASSES',
  FETCHING_AVAILABLE_PASSES = 'FETCHING_AVAILABLE_PASSES',
  FETCH_AVAILABLE_PASSES_SUCCESSFUL = 'FETCH_AVAILABLE_PASSES_SUCCESSFUL',
  BUY_PASS = 'BUY_PASS',
  BUYING_PASS = 'BUYING_PASS',
  BUY_PASS_CONFIRMING = 'BUY_PASS_CONFIRMING',
  BUY_PASS_POLLING = 'BUY_PASS_POLLING',
  BUY_PASS_SUCCESSFUL = 'BUY_PASS_SUCCESSFUL',
  BUY_PASS_FAILED = 'BUY_PASS_FAILED'
}

export interface IFetchActivePassesAction {
  type: typeof WalletTypeKeys.FETCH_ACTIVE_PASSES
  [extraProps: string]: unknown
}

export interface ISetIsFetchingActivePassesAction {
  type: typeof WalletTypeKeys.FETCHING_ACTIVE_PASSES
  [extraProps: string]: unknown
}

export interface IFetchActivePassesSuccessfulAction {
  type: typeof WalletTypeKeys.FETCH_ACTIVE_PASSES_SUCCESSFUL
  payload: IActivePass[]
  [extraProps: string]: unknown
}

export interface IFetchAvailablePassesAction {
  type: typeof WalletTypeKeys.FETCH_AVAILABLE_PASSES
  [extraProps: string]: unknown
}

export interface ISetIsFetchingAvailablePassesAction {
  type: typeof WalletTypeKeys.FETCHING_AVAILABLE_PASSES
  [extraProps: string]: unknown
}

export interface IFetchAvailablePassesSuccessfulAction {
  type: typeof WalletTypeKeys.FETCH_AVAILABLE_PASSES_SUCCESSFUL
  payload: IPassGroup[]
  [extraProps: string]: unknown
}

export interface IBuyPassAction {
  type: typeof WalletTypeKeys.BUY_PASS
  payload: { passId: number, accountId: string }
  [extraProps: string]: unknown
}

export interface ISetIsBuyingPassAction {
  type: typeof WalletTypeKeys.BUYING_PASS
  [extraProps: string]: unknown
}

export interface ISetBuyPassConfirmingAction {
  type: typeof WalletTypeKeys.BUY_PASS_CONFIRMING
  [extraProps: string]: unknown
}

export interface ISetBuyPassPollingAction {
  type: typeof WalletTypeKeys.BUY_PASS_POLLING
  [extraProps: string]: unknown
}

export interface IBuyPassSuccessfulAction {
  type: typeof WalletTypeKeys.BUY_PASS_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface IBuyPassFailedAction {
  type: typeof WalletTypeKeys.BUY_PASS_FAILED
  [extraProps: string]: unknown
}

export type WalletActionTypes =
  | IFetchActivePassesAction
  | ISetIsFetchingActivePassesAction
  | IFetchActivePassesSuccessfulAction
  | IFetchAvailablePassesAction
  | ISetIsFetchingAvailablePassesAction
  | IFetchAvailablePassesSuccessfulAction
  | IBuyPassAction
  | ISetIsBuyingPassAction
  | ISetBuyPassConfirmingAction
  | ISetBuyPassPollingAction
  | IBuyPassSuccessfulAction
  | IBuyPassFailedAction
